import _slicedToArray from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useDecision } from '@optimizely/react-sdk';
import { OPTIMIZELY_FLAGS } from "./optimizelyClient";
export var getVisaAmexEnrolmentFlag = function getVisaAmexEnrolmentFlag() {
  var _useDecision = useDecision(OPTIMIZELY_FLAGS.MCO_VISA_AND_AMEX_ENABLED),
    _useDecision2 = _slicedToArray(_useDecision, 1),
    isVisaAmexEnabled = _useDecision2[0].enabled;
  return isVisaAmexEnabled;
};